import React from 'react';
import SidebarComponent from '../components/SidebarComponent';
import CategoriesListComponent from '../components/CategoriesListComponent';
import HeaderComponent from '../components/HeaderComponent';

class CategoriesListPage extends React.Component {
    render() {
        return (
            <div className="wrapper">
                <SidebarComponent location={this.props.location}/>
                <HeaderComponent/>
                <CategoriesListComponent location={this.props.location}/>
            </div>
        );
    }
}

export default CategoriesListPage;